import { isNil } from 'lodash';
import React, { useContext } from 'react';

/**
 * Utility for creating a context hook under a guard statement to avoid creating context without a required provider.
 * @param context - Context to be created and provided via useContext.
 */
export function createContextHook<TContext extends React.Context<any>>(context: TContext) {
  return (): NonNullable<React.ContextType<TContext>> => {
    const createdContext = useContext(context);

    if (isNil(createdContext)) {
      const contextName = context.displayName || 'Context';

      throw new Error(`[${contextName}] must be used within a ${contextName}Provider`);
    }

    return createdContext;
  };
}
